/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { Route, Redirect } from 'react-router'
import Cookies from 'cookies-js'

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={
      props => (
        Cookies.get('isLogged') !== 'true'
        ? <Redirect
          to={{
            pathname: '/login/',
            state: { from: props.location }
          }}
        />
        : <Component {...props} />
    )}
  />
)

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/generic/router/ProtectedRoute.js